<script lang="ts" setup>
const route = useRoute();
const { selectedSizeId } = storeToRefs(useCatalogStore());

const query = computed(() => {
  return selectedSizeId.value
    ? { ...route.query, tab: 'questions', offer_id: selectedSizeId.value }
    : { ...route.query, tab: 'questions' };
});

const { questions } = storeToRefs(useFeedbackStore());
const { questionsTotalCountPluralized } = useProductFeedback();
</script>

<template>
  <NuxtLink
    :to="{ query, hash: '#feedback' }"
    class="product-page__questions-link"
  >
    <div class="flex flex-col gap-2">
      <div class="flex items-center gap-1">
        <SvgoDialog
          :class="questions.length > 0 ? 'text-hell-black' : 'text-hell-black-40'"
          :font-controlled="false"
          class="size-3"
          filled
        />

        <span v-if="!questions.length">Задать </span>
      </div>

      <span v-if="!questions.length"> вопрос</span>
    </div>

    <template v-if="questions.length">{{ questionsTotalCountPluralized }}</template>
  </NuxtLink>
</template>

<style lang="scss" scoped>
.product-page {
  &__questions-link {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: fit-content;
    padding: 8px;
    border: 1px solid $hell-black-10;
    border-radius: 8px;
    background-color: $white;
    color: $hell-blue;
    font-size: $text-xs;
    text-decoration: none;
    transition: all 0.3s;

    &:hover {
      color: $label-violet;
    }
  }
}
</style>
